import React from 'react';
import { View, Text, StyleSheet, TouchableOpacity, Platform } from 'react-native';
import CS from '../../constants/Styles';
import Colors from '../../constants/Colors';
import Images from '../../constants/Images';
import { Button, ULItem, PhotoId, PhotoIdText, Alert } from '../../components';
import { FontAwesome5 } from '@expo/vector-icons';
import { Camera, CameraType } from 'expo-camera';
import { manipulateImage, dataUrlToFile, isImageExtensionValid } from '../../utils/Functions';
import * as ImagePicker from 'expo-image-picker';
import * as DocumentPicker from 'expo-document-picker';

const VerifyBusiness = ({ businessIdPreview, setBusinessIdPreview, ...props }) => {
  const [loading, setLoading] = React.useState(false);
  const [alertOptions, setAlertOptions] = React.useState({});
  // const [businessIdPreview, setBusinessIdPreview] = React.useState(false);
  const [acceptableIds, setAcceptableIds] = React.useState(["Articles of association",
    "Any other similar record that confirms the existence of the entity",
    "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
  ]);

  let businessIdRef = null;
  let scrollRef = React.useRef(null);

  React.useEffect(() => {
    if (props.structure === 'Corporation') {
      setAcceptableIds([
        "Certificate of incorporation",
        "Certificate of corporate status",
        "Corporate bank statement",
        "Record that has to be filed annually under provincial securities legislation",
        "Published annual report signed by an audit firm",
        "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
        "A document that proves you are a registered corporation and the government recognizes your organization",
      ]);
    } else if (props.structure === 'Partnership') {
      setAcceptableIds([
        "A partnership agreement",
        "Articles of association",
        "Any other similar record that confirms the existence of the entity",
        "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
      ]);
    } else if (props.structure === 'Sole Proprietorship') {
      setAcceptableIds([
        "Articles of association",
        "Any other similar record that confirms the existence of the entity",
        "Letter or notice of assessment from a municipal, provincial, territorial or federal government",
      ]);
    }
  }, [props.structure]);

  // const checkIdentity = () => {
  //   if (!props.businessId) {
  //     let buttonText = props.isContractor ? 'Continue' : 'Sign Up';
  //     setAlertOptions({
  //       visible: true,
  //       title: 'Account Verification',
  //       message: `1 acceptable ID is required to verify your business. Please upload them before hitting "Continue"\n\nSelect "Do It Later" if you do not want, or are unable, to upload your ID. However, please note that your account will remain unverified and you will face restrictions until your account is verified.\n\nYou may upload identification anytime by modifying your profile.`,
  //     });
  //     return;
  //   }
  //   nextRoute();
  // };
  // const skipIdentity = () => {
  //   props.setBusinessId(null);
  //   nextRoute();
  // };
  // const nextRoute = async () => {
  //   props.completeStep('VerifyBusiness');
  // }

  // photos
  const addPhoto = () => {
    let alertButtons = [];
    if (Platform.OS !== 'web') {
      alertButtons = [
        {
          text: 'Take Photo',
          onPress: () => previewBusinessId(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ];
    } else {
      alertButtons = [
        {
          text: 'Choose Photo',
          onPress: () => choosePhoto(),
        },
        {
          text: 'Choose PDF Document',
          onPress: () => choosePDF(),
        }
      ]
    }
    setAlertOptions({
      visible: true,
      title: 'Choose an option',
      message: 'Choose one of the following options.',
      buttons: alertButtons,
      dismissable: true,
    });
  }
  const choosePDF = async () => {
    const result = await DocumentPicker.getDocumentAsync({ type: 'application/pdf' });
    console.log('choosePDF()', result);
    if (result.type === 'success') {
      result.fileType = 'pdf';
      props.setBusinessId(result);
    }
  }
  const previewBusinessId = async () => {
    const permissionResult = await Camera.requestCameraPermissionsAsync();
    if (!permissionResult.granted) {
      setAlertOptions({
        visible: true,
        title: 'Access Denied',
        message: 'Permission to access camera is required!',
      });
      return;
    }
    setBusinessIdPreview(true);
    scrollToEnd();
  }
  const scrollToEnd = () => {
    if(props.scrollView){
      setTimeout(function(){
        props.scrollView.current.scrollToEnd({ animated: true });
      },500);
    }
  }
  const takeBusinessId = async () => {
    console.log('take business id');
    if (businessIdRef) {
      let result = await businessIdRef.takePictureAsync({
        quality: Images.quality,
        base64: false,
        exif: false,
      });
      if (!result.cancelled) {
        result.existing = false;
        console.log('result: ', result);
        const manipResult = await manipulateImage(result, Images.identification.width, Images.identification.height);
        console.log('manipResult: ', manipResult);
        if (!manipResult.cancelled) {
          manipResult.existing = false;
          cancelBusinessIdPreview();
          manipResult.fileType = 'image';
          props.setBusinessId(manipResult);
        }
      }
    }
  }
  const cancelBusinessIdPreview = () => {
    setBusinessIdPreview(false);
  }
  const choosePhoto = async () => {
    let permissionResult = await ImagePicker.requestMediaLibraryPermissionsAsync();
    if (permissionResult.granted === false) {
      setAlertOptions({
        visible: true,
        title: 'Access Denied',
        message: 'Permission to access camera roll is required!',
      });
      return;
    }
    let result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      // aspect: [1, 1],
      quality: 1,
    });
    
    // if (!result.cancelled) {
    //   result.existing = false;
    //   // console.log('image Picker result: ', result);
    //   const manipResult = await manipulateImage(result, Images.identification.width, Images.identification.height);
    //   // const manipResult = await resizeImage(result, Images.identification.width, Images.identification.height);
    //   console.log('manipResult: ', manipResult);
    //   if (!manipResult.cancelled) {
    //     manipResult.existing = false;
    //     if (Platform.OS === 'web') {
    //       manipResult.file = await dataUrlToFile(manipResult.uri);
    //     }
    //     const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? manipResult.file.name : manipResult.uri);
    //     if (!isValidExtension.result) {
    //       alert(`Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`);
    //       return;
    //     }

    //     props.setBusinessId(manipResult);
    //   }
    // }
    if (!result.canceled) {
      result.assets[0].existing = false;
      console.log('result: ', result);
      if (Platform.OS === 'web') {
        result.assets[0].file = await dataUrlToFile(result.assets[0].uri);
      }
      const isValidExtension = isImageExtensionValid(Platform.OS === 'web' ? result.assets[0].file.name : result.assets[0].uri);
      if (!isValidExtension.result) {
        alert(`Invalid image type. Images must end in one of the following extensions: ${isValidExtension.extensions}`);
        return;
      }
      result.assets[0].fileType = 'image';
      props.setBusinessId(result.assets[0]);
    }
  };

  return (
    <>
      <Alert options={alertOptions} setOptions={setAlertOptions} />
      <View style={{ marginBottom: 10 }}>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Your business must be verified in order to receive money. You can setup a project without being verified, however no money can be exchanged.</Text>
        <Text style={[CS.smallText, CS.lightBlueText, { marginBottom: 10 }]}>Your business identification is only used by Renovation Trust personnel for the purposes of verifying your business and is never sold. It is also not shared with contractors or homeowners.</Text>
        <Text style={[CS.smallText, CS.lightBlueText]}>Supported file formats include: jpg, png, tif, gif, webp, pdf</Text>
        <Text style={[CS.smallTitle, CS.lightText, { marginBottom: 0 }]}>Acceptable IDs:</Text>
        <View style={styles.acceptableIdsList}>
          {acceptableIds.map((v, index) => { return (<ULItem text={v} key={index} textColor='lightBlue' />); })}
        </View>
        {/* ids */}
        <View style={styles.ids}>
          {(props.businessId && !props.businessId.existing) &&
            <PhotoId uri={props.businessId.uri} fileType={props.businessId.fileType} fileName={props.businessId.name || ''} remove={props.removeBusinessId} width={props.businessId.width} height={props.businessId.height} />
          }
          {(props.businessId && props.businessId.existing) &&
            <PhotoIdText type={props.businessId.type} version={props.businessId.version} remove={props.removeBusinessId} />
          }
          {businessIdPreview &&
            <View style={styles.businessIdPreviewContainer}>
              <Camera style={styles.businessIdPreview} type={CameraType.back} ref={ref => businessIdRef = ref}>
                <Text style={styles.takeBusinessIdText}>Take a photo of your ID</Text>
              </Camera>
              <View style={CS.rowContainer}>
                <View style={CS.buttonLeft}>
                  <Button text='Cancel' onPress={() => cancelBusinessIdPreview} color='blue' />
                </View>
                <View style={CS.buttonRight}>
                  <Button text='Take Photo' onPress={() => takeBusinessId} />
                </View>
              </View>
            </View>
          }
          {(!businessIdPreview && !props.businessId) && (
            <TouchableOpacity style={styles.addNewId} onPress={addPhoto}>
              <FontAwesome5 name="address-card" size={80} color={Colors.lightBlue} />
              <Text style={[CS.boldText, styles.addNewText]}>Add New</Text>
            </TouchableOpacity>
          )}
        </View>
        <Text style={[CS.smallText, CS.lightBlueText]}>If you have concerns, difficulty or would like to provide alternate forms of identification, please reach out to us.</Text>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  signUp: {
    // width: '100%',
    // marginTop: 'auto',
    // marginBottom: 'auto',
    marginTop: 20,
  },
  acceptableIdsList: {
    marginTop: 10,
    marginBottom: 20,
  },
  ids: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    // marginBottom:20,
  },
  addNewId: {
    // alignItems: 'center',
    // justifyContent: 'center',
    // borderRadius: 10,
    // borderStyle: 'dashed',
    // borderWidth: 2,
    // borderColor: Colors.lightBlue,
    // width: '46%',
    // padding: 10,
    // marginHorizontal: '2%',
    // marginBottom: '4%',

    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 10,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: Colors.lightBlue,
    width: '100%',
    padding: 10,
    marginBottom: '4%',
  },
  addNewText: {
    color: Colors.lightBlue,
    fontSize: 24,
  },
  businessIdPreviewContainer: {
    width: '100%',
    // height: 240,
    aspectRatio: 1,
    marginBottom: 10,
  },
  businessIdPreview: {
    flex: 1,
    borderRadius: 10,
    justifyContent: 'center',
    marginBottom: 10,
    width: '100%',
    // aspectRatio: 1,
  },
  takeBusinessIdText: {
    padding: 20,
    width: '100%',
    backgroundColor: Colors.transparentGrey,
    textAlign: 'center',
    fontSize: 24,
  },
});

export default VerifyBusiness;